// extracted by mini-css-extract-plugin
export default {"root":"countdownTimer_root__vKfb0","timer":"countdownTimer_timer__HPJNy","timer__icon":"countdownTimer_timer__icon__PQxzL","timer__text":"countdownTimer_timer__text__c6FQy"};